<template>
  <svg :width="size" :height="size" viewBox="0 0 16 16" fill="currentColor">
    <path d="M6.22 4.22a.75.75 0 011.06 0l3.25 3.25a.75.75 0 010 1.06l-3.25 3.25a.75.75 0 01-1.06-1.06L8.94 8 6.22 5.28a.75.75 0 010-1.06z"/>
  </svg>
</template>

<script>
export default {
  name: "IconChevronRight",
  props: {
    size: { type: [Number, String], default: 16 },
  },
};
</script>
